module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('SplitLayout', [_c('DrugInfo', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(_vm.currentProgress === 'confirm') ? _c('ConfirmFlow', {
    attrs: {
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "confirmationFinish": _vm.getConfirmData
    }
  }) : _vm._e(), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b769550","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckAmountFlow/MultiFlow.vue
// module id = 1521
// module chunks = 1